export const checkNull = (value) => {
    if (value === null) {
        return null;
    }
    throw new Error(`Expected value to be null, but received ${String(value)}`);
};
